import { createFileRoute, redirect } from '@tanstack/react-router';

import { UserRoles } from '~entities/users';
import { PreflightCheckPage } from '~features/settings/preflight-check/index';
import { checkMinRoleValue } from '~shared/utils/role-guard';

const PendingComponent = () => {
  return (
    <div className='flex h-screen items-center justify-center'>Loading....</div>
  );
};

export const Route = createFileRoute(
  '/_auth/_layout/_settings/preflight-check',
)({
  beforeLoad: async () => {
    const hasAccess = await checkMinRoleValue(UserRoles.ADMIN);
    if (!hasAccess) {
      return redirect({
        to: '/dashboard',
      });
    }
  },
  pendingComponent: PendingComponent,
  component: PreflightCheckPage,
});
